import { SET_USER_SESSION, CLEAR_USER_SESSION } from './actions';

const initialState = {
  user: null,              // Full User object from API (uuid, clinic_uuid, clinician_id, etc.)
  permissions: [],         // User.additionalInfo.permissions — source of truth for RBAC
  authToken: null,         // OAuthDetails.authToken
  refreshToken: null,      // OAuthDetails.refreshToken
  chatSDKAuthDetails: null,
  isHydrated: false,       // true once seeded from API on mount
};

const userSession = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_SESSION:
      return { ...state, ...action.payload };
    case CLEAR_USER_SESSION:
      return { ...initialState };
    default:
      return state;
  }
};

export default userSession;
